import { ApplicationResponseModel } from './ApplicationResponseModel';
import { SettingResponseModel } from './SettingResponseModel';
import { UserMessageResponseModel } from './UserMessageResponseModel';
import { UserSettingResponseModel } from './UserSettingResponseModel';
import { UserShortcutResponseModel } from './UserShortcutResponseModel';

export class DashboardItemResponseModel {
  Applications: Array<ApplicationResponseModel>;
  UserMessages: Array<UserMessageResponseModel>;
  UserShortcuts: Array<UserShortcutResponseModel>;
  UserSettings: Array<UserSettingResponseModel>;
  Settings: Array<SettingResponseModel>;
}